export const isAbortError = (errorInfo: any): boolean => {
  return (
    errorInfo.error?.name === 'AbortError' ||
    (errorInfo instanceof DOMException &&
      errorInfo.message?.includes?.('The play() request was interrupted by a call to pause()'))
  );
};
